import { createFileRoute } from "@tanstack/react-router";
import AdminUserOrganizationRelationshipPage from "@/pages/admin/users/detail/organizations/detail";
import { useUsersPermissions } from "@/pages/admin/users";

export const Route = createFileRoute("/app/admin/users/$userId/organizations/$organizationId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userId, organizationId } = Route.useParams();
  const { userCanViewAllUsers } = useUsersPermissions();

  return (
    <AdminUserOrganizationRelationshipPage
      subjectUserId={Number(userId)}
      organizationId={Number(organizationId)}
      userCanViewAllUsers={userCanViewAllUsers}
    />
  );
}
